import * as React from 'react';
import b_ from 'b_';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { actions } from 'shared/actions/app';
import Tooltip from 'shared/components/Tooltip';
import MoneyView from 'shared/components/MoneyView';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { Money } from 'shared/types/common';
import TariffGridView from 'components/TariffGrid';
import { TariffGridFragment_tariffGrid as TariffGrid } from 'components/TariffGrid/__generated__/TariffGridFragment';

import './index.scss';

import * as hintIcon from './static/img/hintIcon.svg';

interface Props {
  tariffGrid: TariffGrid;
  amount: number;
  balance: number;
  nextLimitIndex: number;
  setAmount: (value: number) => void;
}

type Enhanced = Props &
  InjectedTranslateProps &
  ReturnType<typeof mapDispatchToProps> & { increase: () => void };

const b = b_.with('better-offer-hint');

const mapDispatchToProps = (
  dispatch: Dispatch,
  { balance, tariffGrid: { tariffs }, nextLimitIndex }: Props
) => ({
  deposit: () => {
    const { requestAmount } = tariffs[nextLimitIndex];
    const value = requestAmount - balance;
    return dispatch(actions.showDepositModal({ value: Math.max(value, 0), currency: 'USD' }));
  },
});

const enhance = compose<Enhanced, Props>(
  translate,
  connect(undefined, mapDispatchToProps),
  withProps<Enhanced, Enhanced>((props) => {
    const nextTariff = props.tariffGrid.tariffs[props.nextLimitIndex];
    const increase =
      nextTariff.requestAmount <= props.balance
        ? () => props.setAmount(nextTariff.requestAmount)
        : props.deposit;
    return {
      ...props,
      increase,
    };
  })
);

class BetterOfferHint extends React.Component<Enhanced> {
  render() {
    const { t, tariffGrid, amount, nextLimitIndex, deposit, increase } = this.props;

    const tariff = tariffGrid.tariffs[Math.max(nextLimitIndex - 1, 0)];
    const nextTariff = tariffGrid.tariffs[nextLimitIndex];

    const gap: Money = { value: nextTariff.requestAmount - amount, currency: 'USD' };
    const percent = tariff.enterFee - nextTariff.enterFee + tariff.leaveFee - nextTariff.leaveFee;

    if (percent <= 0 || gap.value <= 0) {
      return null;
    }

    return (
      <div className={b()}>
        <div className={b('body')}>
          <div className={b('text')}>
            {t('Save {{percent}}% on commission', { percent })}{' '}
            <span className={b('link')} onClick={increase}>
              {t('by increasing the amount to')} <MoneyView>{gap}</MoneyView>
            </span>
            <br />
            <br />
            <span className={b('link')} onClick={deposit}>
              {t('Deposit to account')}
            </span>
          </div>
          <Tooltip
            placement="bottomRight"
            trigger={['click']}
            overlay={
              <div className="rc-overlay">
                <TariffGridView grid={tariffGrid} />
              </div>
            }
          >
            <img className={b('hint-icon')} src={hintIcon} alt="?" />
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default enhance(BetterOfferHint);
